import React, { useContext } from "react";
import { InlineMath } from "react-katex";
import { ThemeContext } from "../../context/ThemeContext";

export default function LighthouseDiagram({ angle = 20, height = 45, range = null }) {
  const { theme } = useContext(ThemeContext);
  const textColor = theme === "light" ? "#000000" : "#ffffff";

  // Stały rysunek, ale dynamiczne etykiety
  const fixedAngle = 20;
  const padding = 40;
  const startX = padding;
  const startY = 180;
  const triangleHeight = 140;
  const radians = (fixedAngle * Math.PI) / 180;
  const base = triangleHeight / Math.tan(radians);
  const endX = startX + base;
  const endY = startY - triangleHeight;

  return (
    <svg
      width={base + 2 * padding}
      height={220}
      style={{ display: "block", margin: "0 auto", overflow: "visible" }}
    >
      {/* Tło trójkąta */}
      <polygon
        points={`${endX},${startY} ${startX},${startY} ${startX},${endY}`}
        fill={theme === "light" ? "#f9f9f9" : "#000000"}
        stroke={textColor}
        strokeWidth="2"
      />

      {/* Latarnia jako trapez */}
      <polygon
        points={`
          ${startX - 5},${startY}
          ${startX + 5},${startY}
          ${startX + 2},${endY}
          ${startX - 2},${endY}
        `}
        fill="#cccccc"
        stroke={textColor}
        strokeWidth="1"
      />

      {/* Zasięg (podstawa trójkąta) */}
      <line
        x1={startX}
        y1={startY}
        x2={endX}
        y2={startY}
        stroke="#ff8000"
        strokeWidth="3"
      />

      {/* Światło jako przerywana przeciwprostokątna */}
      <line
        x1={startX}
        y1={endY}
        x2={endX}
        y2={startY}
        stroke="#ff8000"
        strokeWidth="2"
        strokeDasharray="6,4"
      />

      {/* Etykieta wysokości */}
      <foreignObject x={startX - 50} y={(startY + endY) / 2 - 15} width="40" height="30">
        <div style={{ color: textColor, fontSize: "16px", textAlign: "right" }}>
          <InlineMath math={`${height}`} />
        </div>
      </foreignObject>

      {/* Etykieta zasięgu */}
      <foreignObject x={(startX + endX) / 2 - 30} y={startY + 6} width="40" height="30">
        <div style={{ color: textColor, fontSize: "16px", textAlign: "center" }}>
          <InlineMath math={range !== null ? `${range.toFixed(2)}` : "x"} />
        </div>
      </foreignObject>

      {/* Etykieta kąta – dynamiczna wartość */}
      <foreignObject x={endX - 100} y={startY - 25} width="40" height="30">
        <div style={{ color: textColor, fontSize: "14px" }}>
          <InlineMath math={`${angle}^\\circ`} />
        </div>
      </foreignObject>
    </svg>
  );
}
